export const Flag = {
    Report: 'report',
    Kompl: 'kompl',
};
